import { IServiceClient } from './Interfaces';

function secondsToMilliseconds(seconds: number): number {
    return seconds * 1000;
}

export class KeepClientAliveSentinel {
    private interval: any;
    private pingMilliseconds: number = 0;
    private serviceClient: IServiceClient;
    private clientID: string;

    constructor(serviceClient: IServiceClient, clientID: string, sessionTimeoutSeconds: number) {
        if (!serviceClient) {
            throw 'Error'; //sr.noServiceClient;
        }

        this.serviceClient = serviceClient;
        this.clientID = clientID;

        this.initSessionTimeout(sessionTimeoutSeconds);
    }

    private initSessionTimeout(sessionTimeoutSeconds: number) {
        if (!isFinite(sessionTimeoutSeconds)) {
            throw 'sessionTimeoutSeconds must be finite';
        }

        // if small session timeouts are used (2 minutes or less), ping when 50% of the time is remaining
        if (sessionTimeoutSeconds <= 120) {
            this.pingMilliseconds = secondsToMilliseconds(sessionTimeoutSeconds) / 2;
        } else {
            // ping when we have have a minute left
            this.pingMilliseconds = secondsToMilliseconds(sessionTimeoutSeconds - 60);
        }
    }

    start() {
        // negative values and 0 should not be returned by the api, but the actions are overridable so we make sure that we handle this edge case
        if (this.pingMilliseconds <= 0) {
            return;
        }

        this.interval = setInterval(() => {
            this.serviceClient.keepClientAlive(this.clientID);
        }, this.pingMilliseconds);
    }

    stop() {
        if (this.interval) {
            clearInterval(this.interval);
            this.interval = null;
        }
    }
}
